export default __webpack_public_path__ + "static/metal_tile-6a439ed533f92f270e0f81c715b79683.jpg";